/* eslint-disable no-restricted-imports */
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import OriginalGamesFooter from './OriginalGamesFooter';
import StandardGamesFooter from './StandardGamesFooter';
import GameCurrency from '../../../GameCurrencySelect/useGameCurrencySelect/GameCurrency';
import isWebComponentGame from '@/shared/utils/isWebComponentGame';

type Props = {
  gameCurrencySelect: GameCurrency;
  translations: Record<string, string>;
};

const GameFooter: FC<Props> = ({ gameCurrencySelect, translations }) => {
  const { game } = useGameContext();

  if (isWebComponentGame(game?.handle)) {
    return <OriginalGamesFooter />;
  }

  return (
    <StandardGamesFooter
      gameCurrencySelect={gameCurrencySelect}
      translations={translations}
    />
  );
};

export default GameFooter;
